import { RootStore } from './root-store';

/**
 * RootStore의 singleton 인스턴스를 저장
 *
 * React 컴포넌트 외부에서 RootStore에 접근해야 하는 경우를 위한 저장소
 * (예: axios interceptor, 유틸리티 함수 등)
 *
 * React 컴포넌트 내부에서는 useStores() hook 사용
 */

let rootStore: RootStore | null = null;

/**
 * RootStore singleton을 설정
 * App 컴포넌트의 초기화 시점에 한 번만 호출됨
 */
export const setRootStoreSingleton = (store: RootStore) => {
  rootStore = store;
};

/**
 * RootStore singleton을 반환
 *
 * React 컴포넌트 외부에서만 사용해야 합니다.
 * React 컴포넌트 내부에서는 useStores() hook 사용
 *
 * 사용 예시:
 * - axios interceptor
 * - 유틸리티 함수
 * - 외부 라이브러리 콜백
 * - 이벤트 리스너
 *
 * @throws RootStore가 초기화되지 않은 경우 Error
 */
export const getRootStoreSingleton = () => {
  if (!rootStore) {
    throw new Error('RootStore is not initialized');
  }
  return rootStore;
};
